import React, { useState } from 'react';
import { createFormatters } from 'app/infrastructure/data/date';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import * as navigate from 'app/area/shared/navigation';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { getBackRoute } from '../route';
import { FavoriteStickyHeaderProps } from '../types';
import { ReportPanel } from 'app/area/favourite-administration/form/components/report-panel';
import { FavouriteEditMenu } from 'app/area/favourite-administration/form/components/favourite-edit-menu';
import { canDelete, getFavouriteName } from 'app/area/favourite-administration/form/components/helpers';
import { AdjustOwnersModal } from 'app/area/favourite-administration/form/components/adjust-owners-modal';
import styles from './favourite-sticky-header.scss';
import { changeOwners } from 'app/area/favourite-administration/form/utils/change-owners';

export const FavouriteStickyHeader: React.FC<FavoriteStickyHeaderProps> = ({
  favouriteItem, originalFavouriteItem, mainLanguage, name, shouldPrompt, deleting, translation, locale, onSave, onDelete
}) => {

  const [showAdjustOwnersModal, setShowAdjustOwnersModal] = useState(false);

  const formatters: any = createFormatters(locale);

  const created = isDisabled(favouriteItem.disabled);

  const updatingItem = isDefinedIncludingZero(favouriteItem?.id);

  const onCancel = () => {
    navigate.to({ pathname: getBackRoute() });
  };

  const { addedOwners, removedOwners } = changeOwners(favouriteItem, originalFavouriteItem?.owners ?? []);
  const ownersChanged = addedOwners.length > 0 || removedOwners.length > 0;

  const handleSave = () => {
    if (favouriteItem?.parent && ownersChanged) {
      setShowAdjustOwnersModal(true);
    } else {
      onSave();
    }
  };

  const handleModalSave = (applyOnDescendants: boolean) => {
    setShowAdjustOwnersModal(false);
    onSave(applyOnDescendants);
  };

  const handleModalClose = () => {
    setShowAdjustOwnersModal(false);
  };

  const favouriteName = getFavouriteName(favouriteItem, mainLanguage);

  return <>
    {showAdjustOwnersModal && <AdjustOwnersModal
      addedOwners={addedOwners}
      removedOwners={removedOwners}
      favouriteName={favouriteName}
      translation={translation}
      onSave={handleModalSave}
      onClose={handleModalClose} />}
    <StickyHeader
      className={styles.header}
      rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary
            id="favourite-form-sticky-header-cancel-button"
            onClick={onCancel}>
            {translation.cancel}
          </ButtonTertiary>
          <ButtonCallToAction
            id="favourite-form-sticky-header-save-button"
            onClick={handleSave}
            disabled={!shouldPrompt}>
            {translation.update_button}
          </ButtonCallToAction>
        </StickyHeaderButtonContainer>

        {canDelete(favouriteItem.id)
          ? <FavouriteEditMenu
            id={favouriteItem.id}
            name={name}
            translation={translation}
            onDelete={onDelete}
            fetching={deleting}
          /> : null}

      </>} >
      <div className={styles.headerContainer}>
        {updatingItem ? <span className={styles.headerId}>
          #{favouriteItem.id}
        </span> : null}
        <h2 className={styles.headerTitle}>
          {updatingItem
            ? name || null
            : null}
        </h2>
        {(favouriteItem.sharedWithUserGroups.length > 0 || favouriteItem.sharedWithUsers.length > 0)
          ? <Tag className={styles.tag}>{translation.shared}</Tag>
          : null}
        {created ? <Tag>{translation.disabled}</Tag> : null}
      </div>

      <ReportPanel
        data={favouriteItem}
        translation={translation}
        formatters={formatters} />
    </StickyHeader>
  </>;
};
